import { useState, useCallback, useEffect } from "react";
import { VideoBlock } from "../../Builder/LeftPane/Items/VideoBlock";
import { ImageBlock } from "../../Builder/LeftPane/Items/ImageBlock";
import { TextBlock, MathTextBlock } from "../../Builder/LeftPane/Items/TextBlock";
import { LocalVideoBlock } from "../../Builder/LeftPane/Items/LocalVideoBlock";
import { LinkBlock } from "../../Builder/LeftPane/Items/LinkBlock";
import StaticMathDisplay from "../Utility/StaticMathDisplay";
import OptionWrapper from "../Utility/OptionWrapper";

// ─────────────────────────────────────────────
// Block dispatcher
// ─────────────────────────────────────────────

function Block({ item, deletable, width, onSelect, selectedInd }) {
  const props = { item, deletable, width };
  const hasMcq = item.res?.mcq != null;
  const label = hasMcq ? `Option ${item.res.mcq}` : "";
  const isSelected = selectedInd === item.ind;

  const inner =
    item.media === "video"
      ? item.res.local
        ? <LocalVideoBlock {...props} />
        : <VideoBlock {...props} />
      : item.media === "image"
        ? <ImageBlock {...props} />
        : item.media === "text"
          ? item.res.math
            ? <StaticMathDisplay {...props} />
            : <TextBlock {...props} editable={false} />
          : item.media === "link"
            ? <LinkBlock {...props} />
            : null;

  // Fix 3: only wrap if mcq field present
  if (hasMcq) {
    return (
      <OptionWrapper
        label={label}
        isSelected={isSelected}
        onSelect={() => onSelect?.(item.ind)}
      >
        {inner}
      </OptionWrapper>
    );
  }

  return inner;
}

// ─────────────────────────────────────────────
// LeftPanelContent
// ─────────────────────────────────────────────
export default function LeftPanelContent({ question, onClick, panelWidth }) {
  const MARGIN = 24;
  const blockWidth = (panelWidth ?? 320) - MARGIN * 2;

  const items = question?.items ?? [];

  // Sorted by ind
  const sorted = [...items].sort((a, b) => a.ind - b.ind);
    const [selectedInd, setSelectedInd] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        padding: `${MARGIN}px`,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: 16,
        background: "#f7f7f8",
      }}
    >
      {sorted.length === 0 && (
        <p style={{ color: "#aaa", fontSize: 14, textAlign: "center", marginTop: 40 }}>
          No Content.
        </p>
      )}
      {sorted.map(item => (
        <Block
          key={item.ind}
          item={item}
          width={blockWidth}
          deletable={false}
          onSelect={(ind) => {setSelectedInd(ind); onClick(item);}}
          selectedInd={selectedInd}
        />
      ))}
    </div>
  );
}